import type { FC } from 'react'
import { useState } from 'react'
import {
  CwsGridRow,
  CwsGridCol,
  CwsAccordion,
  CwsAccordionItem,
  CwsAccordionItemHeader,
  CwsAccordionItemBody,
  CwsP,
} from '@components/cws'
import type { KKContentItem } from '@api/content'
import ContactUs from '../ContactUs/ContactUs'
import StickyBox from 'react-sticky-box'
import { Returns } from '@components/support/Returns'
import { ReturnsCart } from '@components/support/Returns/ReturnsCart'
import { ContactUsCart } from '@components/support/ContactUs/ContactUsCart'
type ModalTypes = 'item_return' | 'contact_us'
interface SupportListProps {
  content: KKContentItem[]
  modalType: ModalTypes
}
const SupportList: FC<SupportListProps> = ({ content, modalType }) => {
  const [visible, setVisible] = useState(false)
  return (
    <CwsGridRow>
      <CwsGridCol col="12" lg="8">
        <CwsAccordion size="medium">
          {content.map((item) => {
            return (
              <CwsAccordionItem key={item.id} id={`{support-acardion-${item.id}`}>
                <CwsAccordionItemHeader label={item.description.title} />
                <CwsAccordionItemBody>
                  <CwsP dangerouslySetInnerHTML={{ __html: item.description.content }} />
                </CwsAccordionItemBody>
              </CwsAccordionItem>
            )
          })}
        </CwsAccordion>
      </CwsGridCol>
      {modalType === 'contact_us' ? (
        <>
          <CwsGridCol col="12" lg="4">
            <StickyBox offsetTop={140} offsetBottom={0}>
              <ContactUsCart setVisibleModal={setVisible} />
            </StickyBox>
          </CwsGridCol>
          <ContactUs />
        </>
      ) : (
        <>
          <CwsGridCol col="12" lg="4">
            <StickyBox offsetTop={140} offsetBottom={0}>
              <ReturnsCart setVisibleModal={setVisible} />
            </StickyBox>
          </CwsGridCol>
          <Returns visible={visible} setVisible={setVisible} />
        </>
      )}
    </CwsGridRow>
  )
}

export default SupportList
